import React from "react";
import {withTranslation} from "react-i18next";
import winners from '../../resource/GROCWinner.json'
import axios from 'axios';
import Slider from "react-slick";

export const DevChampionServer = "https://dev-api.sgp.981park.com/champion"
export const RealChampionServer = "https://api.sgp.981park.com/champion"


const headers = {
    'Content-Type': 'application/json;charset=UTF-8',
    'X-Authorization-Client-Secret': '586f474c-50b1-11eb-b88b-02d92b41ce80',
    'X-Authorization-Client-Id': '981park-customer-home'
}

class HallOffFame extends React.Component {
	constructor(props) {
        super(props);
		this.state = {
            grocIndex: 0,
            ddayCheck: false,
            lengthIndex: 1, // 마지막 페이지
            indexCount: 5, // 페이지 번호 숫자
            currentIndex: 1, // 현재 페이지
            ranking: []
		};
        var seasonList = []  //eslint-disable-line no-unused-vars
	}


    changGROC = index => () => {
		this.setState({grocIndex: index}, this.requestRanking)
	};

    convertTime(milli) {
        if (milli === 0) {
            return "N/A"
        } else {
            let time = new Date(milli);
            let minutes = time.getUTCMinutes();
            let seconds = time.getUTCSeconds();
            let milliseconds = time.getUTCMilliseconds();
            var secondStr = ""
            var milStr = ""
            if (milliseconds < 10) {
                milStr = "00" + milliseconds
            } else if (milliseconds < 100) {
                milStr = "0" + milliseconds
            } else {
                milStr = "" + milliseconds
            }
            if (seconds < 10) {
                secondStr = "0" + seconds
            } else {
                secondStr = "" + seconds
            }
            return minutes + "’" + secondStr + "”" + milStr;
        }
    }

    convertOrdinal(idx) {
        if (idx === 1) {
            return "1st"
        } else if (idx === 2) {
            return "2nd"
        } else if (idx === 3) {
            return "3rd"
        } else {
            return idx + "th"
        }
        
    }

    convertIndex(idx) {
        if (this.state.ranking != undefined) {
            if (this.state.ranking[idx].xlDnfYn !== true && this.state.ranking[idx].xrDnfYn !== true) {
                return (idx + 1) + ""
            } else {
                return "-"
            }
        } else {
            return "-"
        }
    }

    preIndex = (result) => () => {
        if (result > 0) {
            this.setState({currentIndex: (result - 1) * 5 + 1})
        }
    }

    nextIndex = (result) => () => {
        this.setState({currentIndex: (result + 1) * 5 + 1})
    }

    setIndex = (index) => () => {
        this.setState({currentIndex: index})
    };

    prePhoto = () => () => {
		this.photo.slickPrev();
	}

	nextPhoto = () => () => {
		this.photo.slickNext();
	}

    grocList() {
        if (winners != undefined) {
            var win = []
            for (var k = 0; k < winners.length; k++) {
                const aCell = <div onClick={this.changGROC(k)} style={{cursor: "pointer"}} className={this.state.grocIndex === k ? "tab selected" : "tab"} ><a className="typo1">{"GROC " + winners[k].year}</a></div>
                win.push(aCell)
            }
            return win
        } else {
            return null
        }
    }

    winnerRoundRanking() {
        var rankings = []  //eslint-disable-line no-unused-vars
        var data = winners[this.state.grocIndex];
        if (data.round.length === 1) {
            return <span className="s-txt">{data.round[0]}</span>
        } else if (data.round.length === 2) {
            return <span className="s-txt">{data.round[0]}<br/>{data.round[1]}</span>
        } else {
            return null
        }
    }

    ranking() {
        var aDivs = []
        if (this.state.ranking != undefined) {
            var rows = []
            for (var i = (this.state.currentIndex - 1) * 10; i < (this.state.currentIndex) * 10; i++) { 
                var rowClass = "row"
                if (i < 3) {
                    rowClass = rowClass + " groc-rk"
                }
                
                var labelClass = "label"
                if (i < this.state.ranking.length) {
                    if (this.state.ranking[i].roundRanking === 1) {
                        labelClass = labelClass + " rk1"
                    }
                    var srcString = ""
                    if (this.state.ranking[i].thumbnailImageUrl === null) {
                        srcString = "https://asset.981park.com/www/common/web/img/sub/groc/icon-profile-empty-large.png"
                    } else {
                        srcString = this.state.ranking[i].thumbnailImageUrl
                    }
                    const cell = <div className={rowClass}>
                                    <ul>
                                        <li><div className="num">{this.state.ranking[i].ranking === null ? "-" : this.state.ranking[i].ranking}</div></li>
                                        <li>
                                            <div className="rk-user">
                                                <span className="img-wrap"><span className="img"><img src={srcString} alt=""/></span></span>
                                                <span className="name"><span className="txt">{this.state.ranking[i].nickName}</span></span>
                                            </div>
                                        </li>
                                        <li><div className="num">{(this.state.ranking[i].dnfYn === true) ? "N/A" : this.convertTime(this.state.ranking[i].xlLaptime + this.state.ranking[i].xrLaptime)}</div></li>
                                        <li>
                                            <div className="track"><span className="num">{this.state.ranking[i].xlDnfYn ? "N/A" : this.convertTime(this.state.ranking[i].xlLaptime)}</span></div>
                                            <div className="track"><span className="num">{this.state.ranking[i].xrDnfYn ? "N/A" : this.convertTime(this.state.ranking[i].xrLaptime)}</span></div>
                                        </li>
                                    </ul>
                                </div>
                    rows.push(cell)
                }
            }
            var result = Math.floor(this.state.currentIndex/this.state.indexCount)
            if (this.state.currentIndex % this.state.indexCount === 0) {
                result = result - 1
            }
            var start = (result * this.state.indexCount + 1)
            var last = ((result + 1) * this.state.indexCount + 1)
            if (last > this.state.lengthIndex) {
                last = this.state.lengthIndex + 1
            }
            for (var k = start; k < last; k++) { 
                const aCell = <a style={{cursor: "pointer"}} className={this.state.currentIndex == (k) ? "active" : ""} onClick={this.setIndex(k)}>{k}</a>
                aDivs.push(aCell) 
            }
        }
        return <div className="ranking-list">
            <div className="list">
                <div className="row list-head">
                    <ul>
                        <li><div className="txt">RK</div></li>
                        <li><div className="txt">RACER</div></li>
                        <li><div className="txt">TOTAL(L+R)</div></li>
                        <li>
                            <div className="track"><span className="txt">L TRACK</span></div>
                            <div className="track"><span className="txt">R TRACK</span></div>
                        </li>
                    </ul>
                </div>
                {rows}
            </div>
            <div className="paging">
                <a className={"arrow prev " + ((result === 0) ? "disabled" : "")} onClick={this.preIndex(result)}><span className="blind">prev</span></a>
                {aDivs}
                <a className={"arrow next " + ((last > this.state.lengthIndex) ? "disabled" : "")} onClick={this.nextIndex(result)}><span className="blind">next</span></a>
            </div>
        </div>
    }

    componentDidMount() {
        /*if (window.location.hostname === "localhost" || window.location.hostname === "dev-home.981park.net") {
            this.server = DevChampionServer
        } else {
            this.server = RealChampionServer
        }*/

        // C.Final 서버 설정 (dev / prod)
        // this.server = DevChampionServer
        this.server = RealChampionServer

        this.requestSeason()
    }

    requestSeason() {
        axios({
            url:`${this.server}/homepage/years`,
            method: 'get',
            headers: headers
        }).then(response => {
            this.seasonList = response.data.data
            this.requestRanking()
        })
    }

    requestRanking() {
        var returnIndex= this.seasonList.find(i => i.year === winners[this.state.grocIndex].year)

        if(returnIndex != undefined) {
            axios({
                url:`${this.server}/homepage/singles/${returnIndex.championsSeq}`,
                method: 'get',
                headers: headers
            }).then(response => {
                var last = Math.ceil(response.data.data.length / 10)
                this.setState({ranking: response.data.data, lengthIndex: last, currentIndex: 1})
            })
        } else {
            this.setState({ranking: '', lengthIndex: 1, currentIndex: 1})
        }
    }

	render() {
		const {t} = this.props;

        const baseSettings = {
            slidesToShow: 3,
            slidesToScroll: 1,
        };

        const photoSettings = {
            ...baseSettings,
            variableWidth: true,
        };

        const tabSettings = {
            ...baseSettings,
            infinite: false,
        };

        var data = winners[this.state.grocIndex];
        var imgDiv =[]
        var photoList = null
        for (var k=0; k<data.images.length; k++) {
            const cell = <div className="photo"><img src={data.images[k]} alt=""/></div>
            imgDiv.push(cell)
        }
        if (data.images.length !== 0) {
            photoList = <div className="groc-photo-list">
                        <div className="photo-inner">
                            <div className="groc-slider-arrow-button">
                                <button onClick={this.prePhoto()} className="photo-arrow-btn photo-arrow-prev"></button>
                                <button onClick={this.nextPhoto()} className="photo-arrow-btn photo-arrow-next"></button>
                            </div>
                        
                            <div className="photo-ttl">{data.year + " " + t('Groc_photos')}</div>
                        </div>
                        <div className="photo-list">
                            <Slider ref={c => (this.photo = c)} {...photoSettings}>
                                {imgDiv}
                            </Slider>
                        </div>														
                    </div>
                    
        }
		return (
			<>
			    <div className="content-wrap sub-content sub-groc sub-groc-v2">
                <div className="visual-wrap">
                    <div className="visual-slide-wrap">
                        <div className="visual-slide-list">
                            <div className="slide">
                                <div className="img">
                                    <img src="https://asset.981park.com/www/common/web/img/sub/groc/slide-groc-hall-of-fame1.png" alt="9.81 파크의 대표 액티비티, 친환경 그래비티 레이싱!"/>
                                </div>
                            </div>
                        </div>

                        <div className="visual-slide-text">
                            <div className="inner">
                                <div className="con">
                                    <div className="text-wrap color1">
                                        <p className="s-text typo1">HALL OF FAME</p>
                                        <p className="m-text">{t('Groc_hall_title1')} <br/> {t('Groc_hall_title2')}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="tab-menu-wrap">
                    <div className="inner">
                        <div className="tab-menu">
                            <Slider {...tabSettings}>
                                {this.grocList()}
                            </Slider>
                        </div>
                    </div>
                </div>

                <div className="tab-con-wrap">
                    <div className="tab-con groc2021 on">
                        <div className="groc-list-wrap">
                            <div className="inner">
                                <div className="groc-list">
                                    <div className="groc">
                                        <div className="groc-inner">
                                            <div className="groc-chanpion-ttl">
                                                <div className="groc-list-ttl"><span className="typo1">{data.year + " GROC CHAMPION"}</span></div>
                                            </div>

                                            <div className="groc-chanpion-info">
                                                <div className="chanpion-img">
                                                    <div className="img-wrap"><img src={data.profile} alt=""/></div>
                                                    <div className="img-txt typo1">{data.year + " CHAMPION"}</div>
                                                </div>
                                                <div className="chanpion-info">
                                                    <div className="chanpion-info-ttl typo1">CHAMPION PROFILE</div>
                                                    <ul className="chanpion-info-list">
                                                        <li>
                                                            <div className="row row-line">
                                                                <div className="ttl">{t('Groc_nick_name')}</div>
                                                                <div className="ttl">{t('Groc_car_number')}</div>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className="row">
                                                                <div className="txt"><span className="m-txt">{data.nickName}</span></div>
                                                                <div className="txt"><span className="m-txt">{data.car}</span></div>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className="row row-line">
                                                                <div className="ttl">{t('Groc_lap_time')}</div>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className="row">
                                                                <div className="txt">
                                                                    <span className="typo2 lgst-txt">{data.lTime}</span>
                                                                    <span className="typo1 s-label-txt">X/L</span>
                                                                </div>
                                                                <div className="txt">
                                                                    <span className="typo2 lgst-txt">{data.rTime}</span>
                                                                    <span className="typo1 s-label-txt">X/R</span>
                                                                </div>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className="row row-line">
                                                                <div className="ttl">{t('Groc_championship_rule')}</div>
                                                                <div className="ttl">{t('Groc_round_score')}</div>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className="row">
                                                                <div className="txt">
                                                                    <span className="s-txt">{t('Groc_sub_title_1')} <br/> {t('Groc_sub_title_2')} <br/> {t('Groc_sub_title_3')}</span>
                                                                </div>
                                                                <div className="txt">
                                                                    {this.winnerRoundRanking()}
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        {photoList}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="groc-ranking">
                            <div className="inner">
                                <div className="ttl-area">
                                    <div className="ttl">{"GROC " + data.year + " " + t('Groc_final_ranking')}</div>
                                </div>
                                {this.ranking()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
		);
	}
}
export default withTranslation()(HallOffFame);